import React, { Component } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';
import Actions_Wind from '~/Actions_Wind';
import { T_TitleCell, T_TableRow } from '~/components/TableItem';
import * as getStatus from '~/skills/getStatus';

import BCIF_Container from '../BCIF_Container';

class List extends Component {
  state={
    per_page: 10,
    page: 1,
    sort: true,
    sort_field: 'upd_time',
  }

  componentDidMount () {
    this.refresh();
  }

  refresh=() => {
    const { windId } = this.props;
    const { page, per_page, sort, sort_field } = this.state;
    this.props.getAProList({
      page,
      per_page,
      body: {
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
      windId,
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());
  _click_search=this.search;

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '程序文件', id: 'proc_type' },
      { name: '預訂申請時間', id: 'reserve_apply_time' },
      { name: '預定完成時間', id: 'reserve_get_time' },
      { name: '實際申請時間', id: 'actual_apply_time' },
      { name: '實際達成時間', id: 'actual_get_time' },
      { name: '表單狀態', id: 'form_status' },
      { name: '申請狀態', id: 'apply_status' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
              backgroundColor='#EBF3F5'
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { AProList = {} } = this.props;
    const { list = [] } = AProList;
    const cellStyle = { fontSize: 14 };
    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? 'transparent' : 'white'}>
            <TableCell align='left' style={cellStyle}>{o.proc_type}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.reserve_apply_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.reserve_get_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actual_apply_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actual_get_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{getStatus.form(o)}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.apply_status}</TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTable=() => {
    const { AProList = {} } = this.props;
    const { list = [] } = AProList;
    const haveData = list.length > 0;
    return (
      <TableContainer>
        <Table style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  renderTableBar=() => {
    const { AProList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = AProList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '100%', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  render () {
    const { AProList = {} } = this.props;
    const { list = [] } = AProList;
    const haveData = list.length > 0;
    return (
      <div>
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
      </div>
    );
  }
}

const App = ({ windId }) => {
  const dispatch = useDispatch();
  const getAProList = body => Actions_Wind.getAProList(dispatch, body);
  const clear = body => Actions_Wind.clearKey(dispatch, { key: 'AProList' });
  const AProList = useSelector(state => state.data.AProList || []);

  return (
    <BCIF_Container title='各項許可進度' defaultOpen={false}>
      {/* <Select>
        <MenuItem value={1}>1</MenuItem>
        <MenuItem value={2}>12</MenuItem>
      </Select> */}
      <List {...{ getAProList, AProList, clear, windId }} />
    </BCIF_Container>
  );
};

export default App;
